<template lang="pug">
    .multiselect-filter-wrapper(v-on:mouseleave="handleMouseLeave")
        .label {{ getLabel }}
        .list-wrapper
            .row(v-for="target in filter.targets" :key="target.id" @click="handleClick(target)")
                .box(:class="{ 'selected-box': activeFilters[filter.key].find(item => item.id === target.id) }")
                    .check(v-if="activeFilters[filter.key].find(item => item.id === target.id)") &#10003;
                .name {{ target.name }}
</template>

<script>
export default {
    // eslint-disable-next-line
    props: ['filter', 'activeFilters'],
    computed: {
        getLabel() {
            const { label, targets } = this.filter
            return `Select ${label.toLowerCase()} (${targets.length})`
        }
    },
    methods: {
        handleClick(target) {
            const { key } = this.filter
            this.$emit('multiselection', 'update', { ...target, key })
        },
        handleMouseLeave() {
            this.$emit('closeSelection')
        }
    }
}
</script>
